import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IMAGE_PATHS } from 'libs/constants';
import colors from 'assets/styles/jsVariables/colors';
import { endPoints } from 'config/routes';
import { redirectTo, hasSubscription } from 'libs/common';
import config from 'config';
import HeaderLayout from './HeaderLayout';

const { MSWEB } = config;

const headerProps = {
  logoRedirect: {
    url: MSWEB.URL,
    refresh: true
  },
  rootStyle: {
    background: colors.white
  },
  profileIconStyle: {
    width: '30px',
    height: '30px'
  },
  chevronIconStyle: {
    width: '16px',
    height: '16px'
  },
  popoverIconFill: '#CECECE'
};

function HeaderLayoutMs(props) {
  const {
    userSubscriptions, location
  } = props;
  const isPlanSubs = hasSubscription(userSubscriptions);
  if (isPlanSubs && location.pathname === endPoints.products.ms.default) {
    redirectTo(endPoints.subscriptions);
    return null;
  }

  return (
    <div className="Layout--Header--Ms">
      <HeaderLayout
        {...props}
        headerImagePaths={IMAGE_PATHS.HeaderLayoutMs}
        headerProps={headerProps}
      />
    </div>
  );
}

HeaderLayoutMs.propTypes = {
  userSubscriptions: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
};

function mapStateToProps({
  auth, windowLocation
}) {
  return {
    userSubscriptions: (auth.info && auth.info.subscriptions) || [],
    location: windowLocation.location
  };
}

export default connect(mapStateToProps)(HeaderLayoutMs);



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderLayout/HeaderLayoutMs.jsx